/**
 * Compute the per-hour pixel height for the Day/Week time grids, scaling to
 * fill the measured container height while never dropping below the
 * mode-specific minimum.
 *
 * Issue #3619: the grid previously used a fixed `base` per-hour height, so on a
 * tall window the inner grid (time gutter + day columns) stayed short and a
 * large blank gap appeared below the last hour. Scaling per-hour height by the
 * ResizeObserver-measured body height makes the grid fill the available space.
 *
 * `visibleHours` is passed by the caller (DayView/WeekView read
 * `visibleHours.length`, the scroll effect passes `DAY_GRID_VISIBLE_HOURS`) so
 * the formula is robust to the grid's hour count without hardcoding it here.
 *
 * On first paint the ResizeObserver has not measured the container yet
 * (`dayWeekBodyHeight <= 0`), so we return the base height — the caller's
 * existing `12 * HOUR_HEIGHT` first-paint fallback then computes against base.
 */
export function computeHourHeight(
  isMobile: boolean,
  isExpandedView: boolean,
  dayWeekBodyHeight: number,
  visibleHours: number,
): number {
  const base = isMobile ? 40 : isExpandedView ? 96 : 48;
  if (dayWeekBodyHeight <= 0) return base;
  return Math.max(base, Math.floor(dayWeekBodyHeight / visibleHours));
}
